import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class SelectController extends Controller {
  connect() {
    this.select = new SlimSelect({select: this.element})
  }

  disconnect() {
    this.select.destroy()
  }
}
